import { render } from "./OrderModificationTable.vue?vue&type=template&id=172e2478"
import script from "./OrderModificationTable.vue?vue&type=script&lang=js"
export * from "./OrderModificationTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__